import React, { memo, useCallback, useMemo } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Container, Divider, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

function Modal({ 
    open, 
    handleClose, 
    handleConfirm, 
    redirect,
    title, 
    description, 
    labelConfirm, 
    labelCancel,
    disableConfirm,
    disableCancel,
    disableEscapeKeyDown,
    hideImportant, 
    ...others 
}) {

    const navigate = useNavigate()
    
    const redirectPage = useCallback(() => {
        navigate(redirect, {replace: true })
        handleConfirm && handleConfirm()
    }, [navigate, redirect, handleConfirm])
    
    const { 
        modalLabelConfirm, 
        modalLabelCancel, 
        modalDisableEscapeKeyDown, 
        modalRedirect 
    } = useMemo( () => {
        return { 
            modalLabelConfirm: labelConfirm ? labelConfirm : 'Sim', 
            modalLabelCancel: labelCancel  ? labelCancel  : 'Cancelar',
            modalDisableEscapeKeyDown: disableEscapeKeyDown ? true: false,
            modalRedirect: redirect !== undefined && redirect ? redirectPage : handleConfirm
        }
    }, [
        labelConfirm, 
        labelCancel, 
        disableEscapeKeyDown, 
        redirect, 
        redirectPage, 
        handleConfirm
    ])
    //const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
    
    if (!description) return null
     
    return (
        <Container {...others}>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableEscapeKeyDown={modalDisableEscapeKeyDown}
                //fullScreen={fullScreen}
            >
                <DialogTitle id="alert-dialog-title">
                   {title}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description" component='div' sx={{padding: '0'}}>
                    {typeof description === 'string' ? <div dangerouslySetInnerHTML={{__html: description}} /> : description}
                    <Divider sx={{margin: '10px 0'}} />
                    {!hideImportant && <Typography variant={'body1'} color="error.main" fontSize={'9px'}>
                        *IMPORTANTE {<br/>}
                        CADASTRO SUJEITO A ALTERAÇÃO NA RECEPÇÃO. {<br/>} 
                        AUTORIZAÇÃO DO CONVÊNIO SERÁ SOLICITADA NA RECEPÇÃO. {<br/>}
                    </Typography>}
                    {/* <Typography variant={'body1'} color="error.main">
                        
                    </Typography> */}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {!disableCancel && <Button 
                        sx={{ 
                            backgroundColor: process.env?.REACT_APP_BUTTON_STYLE_BG, 
                            color: '#fff',
                            '&:hover': {
                                bgcolor: process.env?.REACT_APP_BUTTON_STYLE_HOVER
                            } 
                        }}
                        //variant='contained'
                        onClick={handleClose}
                    >{modalLabelCancel}</Button>}
                    {!disableConfirm && <Button 
                        sx={{
                            color: '#fff', 
                            '&:hover': {
                                bgcolor: process.env?.REACT_APP_BUTTON_STYLE_HOVER
                            },
                            backgroundColor: process.env?.REACT_APP_BUTTON_STYLE_BG,   
                            
                        }}
                        //variant='contained'
                        onClick={modalRedirect} >
                        {modalLabelConfirm}
                    </Button>}
                </DialogActions>
            </Dialog>
        </Container>
    )
}

export default memo(Modal)